import type { GetPeopleExportParams, GetPeopleListParams } from './type';

export const peopleListKeys = {
  all: ['people-list'] as const,
  list: (params: GetPeopleListParams) =>
    [...peopleListKeys.all, 'list', params] as const,
} as const;

export const workforceKeys = {
  all: ['workforce'] as const,
  count: () => [...workforceKeys.all, 'count'] as const,
  export: (params: GetPeopleExportParams) =>
    [...workforceKeys.all, 'export', params] as const,
} as const;
